import React, { createElement, useEffect, useState } from 'react';
import cls from 'classnames/bind';
import style from './index.module.scss';
import { Form, Col } from 'antd';
import { generateRules } from '../../../utils';
import ErrorBoundary from '../../common/errorBoundary';
import ErrorComponent from '../../common/errorComponent';
import PersonnelDialog from './personnelDialog';
const cx = cls.bind(style);
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const FormPersonnel = (props, ref) => {
    const { title, __id, rules, status, span, column, form, maxTagCount, ...other } = props;
    const [error, setError] = useState(false);
    const [errmsg, setErrmsg] = useState(null);
    const [rule, setRule] = useState([]);
    useEffect(() => {
        try {
            setRule(generateRules(rules, 'array'));
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('校验规则初始化出错,检查配置或更新组件');
        }
    }, [rules]);
    const [ops, setOps] = useState([]);
    useEffect(() => {
        setError(false);
        try {
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('选项初始化出错,检查配置或更新组件');
        }
    }, []);
    const setOptions = ({ data }) => {
        if (data.type === 'organizationalTree:change') {
            const list = data.data;
            if (list.length) {
                console.log('接收到了通知', list);
            }
            else {
                setOps([]);
            }
        }
    };
    return (createElement(ErrorBoundary, null, error ? (createElement(ErrorComponent, { ref: ref, errmsg: errmsg })) : (createElement(Col, { span: column || span },
        createElement("div", { ref: ref, className: "base_bg" },
            createElement(Form.Item, { label: title || '下拉复选', name: __id || props.componentId, rules: rule },
                createElement(PersonnelDialog, { mode: props.__designMode, value: form.getFieldsValue(__id), setError: setError, setErrmsg: setErrmsg })))))));
};
export default React.forwardRef(FormPersonnel);
